export default __webpack_public_path__ + "static/media/burger.305df11f.png";